import React from 'react';
import { PanelHeader } from '@apply/components';
import { Button, ButtonTheme } from '@apply/components';
import { IDrawBudget } from '@apply/api/src/api/DrawApi';
import { MobileDrawItem } from './MobileDrawControl';
import { formatCurrency } from '@apply/ui';
import { useNavigate } from 'react-router-dom';

interface MobileDrawHeaderParameters {
    drawBudget?: IDrawBudget;
    mobileDrawItems?: MobileDrawItem[];
    hideFullyFunded: boolean;
    onToggleFullyFunded: any;
    saveMobileDraw: () => void;
}

export const MobileDrawHeader: React.FC<MobileDrawHeaderParameters> = ({
    drawBudget,
    mobileDrawItems,
    hideFullyFunded,
    onToggleFullyFunded,
    saveMobileDraw,
}) => {
    const navigate = useNavigate();

    const onSaveFinishLaterClick = () => {
        saveMobileDraw();
        navigate('/home');
    };

    return (
        <PanelHeader>
            <div className='mobileDrawHeader'>
                <div className='drawInfo'>
                    <div className='number'>Draw #{drawBudget?.drawCount}</div>
                    <div className='address'>{drawBudget?.propertyAddress}</div>
                </div>
                <div className='drawAmount'>
                    <div className='amount'>
                        {mobileDrawItems && mobileDrawItems.length > 0
                            ? formatCurrency(
                                  mobileDrawItems?.reduce((sum, value) => (sum += value?.borrowerRequest ?? 0), 0),
                                  2
                              )
                            : formatCurrency(0, 2)}
                    </div>
                    <div className='description'>Total Draw</div>
                </div>
            </div>
            <div className='mobileDrawHeaderActions'>
                <div
                    className='checkbox'
                    style={{ marginTop: '17px' }}
                >
                    <input
                        id='hideFullyFunded'
                        key='hideFullyFunded'
                        type='checkbox'
                        checked={hideFullyFunded}
                        onChange={(e) => onToggleFullyFunded(e.target.checked)}
                    />
                    Hide Fully Funded
                </div>
                <div>
                    <Button
                        id='saveFinishButton'
                        theme={ButtonTheme.Secondary}
                        width={'160px'}
                        handleClick={onSaveFinishLaterClick}
                    >
                        Save / Finish Later
                    </Button>
                </div>
            </div>
        </PanelHeader>
    );
};
